import React from 'react';
import BreadcrumbsWrapper from 'components/Wrapper/BreadcrumbsWrapper';

const SupportUsersHeader = () => {
    return (
        <>
            <div>
                <BreadcrumbsWrapper />
            </div>
        </>
    );
};

export default SupportUsersHeader;